import { hasAttr } from "@util/Obj";


export const feature = (feature, state) => hasAttr(state.present, feature) ? state.present[feature] : null